import { useEffect } from 'react';

/** Sets document.title for a public route; restores the bare app title on unmount. */
export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = title;
    return () => {
      document.title = 'Markcat';
    };
  }, [title]);
}
